import type { SearchSuppliersInput } from '@travel-planner/shared/schemas/operations';
import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

export const useSearchSuppliers = (
  input: SearchSuppliersInput,
  options?: Options
) =>
  trpc.operations.searchSuppliers.useQuery(input, {
    enabled: options?.enabled ?? true,
  });
